import React from 'react';

export const UsersListHeader = () => {
    return (
        <li className="list-group-item">
            <div className="row d-flex d-lg-none">
                <div className="col">
                    <h3 className="text-center h4 lg-0">Users list</h3>
                </div>
            </div>
            <div className="row d-none d-lg-flex">
                <div className="name-header col-lg-3 col-xl-4">
                    <p className="my-1">
                        <strong>Name</strong>
                    </p>
                </div>
                <div className="email-header col-lg-4 col-xl-4">
                    <p className="my-1">
                        <strong>Email</strong>
                    </p>
                </div>
                <div className="role-header col-lg-2 col-xl-2">
                    <p className="my-1">
                        <strong>Role</strong>
                    </p>
                </div>
                <div className="actions-header col-lg-3 col-xl-2">
                    <p className="text-center my-1">
                        <strong>Actions</strong>
                    </p>
                </div>
            </div>
        </li>
    );
};
